import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Lock, Loader2, FileUp, Clock, XCircle } from 'lucide-react';
import api from '@/lib/api';
import CourseProfessionalPage from '@/pages/CourseProfessionalPage';

const STATUS_HINT = {
  none: 'Crie seu Perfil Profissional e envie seu certificado. Assim que a equipe validar, o acesso é liberado.',
  draft: 'Complete seu Perfil Profissional e envie seu certificado para validação.',
  pending: 'Seus documentos estão em análise. Avisaremos pelo sininho assim que o acesso for liberado.',
  rejected: 'Seu perfil precisa de ajustes. Corrija os dados e envie de novo.',
};

export default function PareiAdGatePage() {
  const [state, setState] = useState(null);

  useEffect(() => {
    api.get('/courses/parei-ad/access').then((r) => setState(r.data)).catch(() => setState({ access: false, professional_status: 'none' }));
  }, []);

  if (!state) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-purple-500" /></div>;
  if (state.access) return <CourseProfessionalPage />;

  const status = state.professional_status;
  const Icon = status === 'pending' ? Clock : status === 'rejected' ? XCircle : Lock;
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4" data-testid="parei-ad-locked">
      <Card className="max-w-lg w-full bg-slate-900 border-white/10">
        <CardContent className="p-6 sm:p-8 text-center space-y-5">
          <div className="mx-auto h-14 w-14 rounded-full bg-purple-600/20 flex items-center justify-center"><Icon className="h-7 w-7 text-purple-400" /></div>
          <div className="space-y-2">
            <p className="text-xs uppercase tracking-[0.2em] text-purple-300 font-semibold">Formação PAREI-AD</p>
            <h1 className="text-2xl sm:text-3xl font-bold text-white" data-testid="parei-ad-locked-title">Acesso exclusivo para profissionais verificados</h1>
            <p className="text-sm text-slate-400" data-testid="parei-ad-locked-hint">{STATUS_HINT[status] || STATUS_HINT.none}</p>
            {status === 'rejected' && state.reject_reason && <p className="text-sm text-red-400" data-testid="parei-ad-reject-reason">Motivo: {state.reject_reason}</p>}
          </div>
          {status !== 'pending' && (
            <Button asChild className="w-full min-h-[48px] gap-2 bg-purple-600 hover:bg-purple-700" data-testid="parei-ad-send-docs-btn">
              <Link to="/profile/professional"><FileUp className="h-4 w-4" /> Enviar documentação</Link>
            </Button>
          )}
          <Link to="/feed" className="block text-sm text-slate-400 hover:text-white" data-testid="parei-ad-back-link">Voltar para o Feed</Link>
        </CardContent>
      </Card>
    </div>
  );
}
